import React from 'react';

export const MasterHeader = ({
  breadcrumbs = [],
  title,
  description,
  subtitle,
  icon,
  metrics = [],
  actions = null,
  primaryAction = null,
  actionLabel,
  onAction
}) => {
  const finalDesc = description || subtitle;
  const finalActionLabel = primaryAction?.label || actionLabel;
  const finalActionClick = primaryAction?.onClick || onAction;

  return (
    <div className="mst-page-header">
      <div className="mst-header-left">
        {breadcrumbs && breadcrumbs.length > 0 && (
          <nav className="mst-breadcrumb" aria-label="Breadcrumb">
            {breadcrumbs.map((b, idx) => (
              <React.Fragment key={idx}>
                {idx > 0 && <span className="mst-breadcrumb-sep">/</span>}
                {b.href ? (
                  <a href={b.href} style={{ color: 'inherit', textDecoration: 'none' }}>
                    {b.label}
                  </a>
                ) : (
                  <span>{b.label}</span>
                )}
              </React.Fragment>
            ))}
          </nav>
        )}

        <div className="mst-header-title-row">
          {icon && <span className="mst-header-icon">{icon}</span>}
          <h1 className="mst-page-title">{title}</h1>
          {metrics && metrics.length > 0 && (
            <div className="mst-metrics-strip">
              {metrics.map((m, idx) => (
                <div key={idx} className="mst-metric-pill">
                  <span className="mst-metric-count">{m.value ?? 0}</span>
                  <span className="mst-metric-lbl">{m.label}</span>
                </div>
              ))}
            </div>
          )}
        </div>

        {finalDesc && <p className="mst-page-desc">{finalDesc}</p>}
      </div>

      <div className="mst-header-right">
        {actions ? actions : (
          finalActionLabel && finalActionClick && (
            <button
              type="button"
              className="mst-btn-primary"
              onClick={finalActionClick}
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <line x1="12" y1="5" x2="12" y2="19" />
                <line x1="5" y1="12" x2="19" y2="12" />
              </svg>
              {finalActionLabel.replace(/^\+\s*/, '')}
            </button>
          )
        )}
      </div>
    </div>
  );
};

export default MasterHeader;
